import { UserRole } from 'shared/types/userRole';

export const isStandard = (role: UserRole): boolean => {
  return role === UserRole.standard;
};
